import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import { alpha, useTheme } from "@mui/material/styles";
import OrdersMap from "../map/ordersMap";

const FloatingMapPreview = ({ show, onClose }) => {
  const theme = useTheme();

  const handleMouseLeave = () => {
    onClose();
  };

  const handleCloseClick = () => {
    onClose();
  };

  const getContainerStyles = () => {
    return {
      position: "fixed",
      top: 16,
      left: 16,
      width: { xs: "calc(100vw - 32px)", sm: 400, md: 700 },
      height: { xs: 300, sm: 350, md: 600 },
      zIndex: 1300,
      borderRadius: "6px",
      overflow: "hidden",
      boxShadow: theme.shadows[6],
      bgcolor: "background.paper",
      border: `1px solid ${theme.palette.divider}`,
    };
  };

  const getCloseButtonStyles = () => {
    return {
      position: "absolute",
      top: 8,
      right: 8,
      zIndex: 1301,
      bgcolor: alpha(theme.palette.background.paper, 0.9),
      borderRadius: "4px",
    };
  };

  const getCloseIconStyles = () => {
    return {
      color: theme.palette.text.primary,
      "&:hover": {
        bgcolor: alpha(theme.palette.action.hover, 0.1),
      },
    };
  };

  const getTitleStyles = () => {
    return {
      position: "absolute",
      top: 8,
      left: 8,
      zIndex: 1301,
      bgcolor: alpha(theme.palette.background.paper, 0.9),
      borderRadius: "4px",
      px: 1,
      py: 0.5,
    };
  };

  const getTitleTextStyles = () => {
    return {
      fontWeight: 600,
      color: theme.palette.primary.main,
    };
  };

  const getMapContainerStyles = () => {
    return {
      width: "100%",
      height: "100%",
      pointerEvents: "none",
    };
  };

  return (
    <Slide direction="right" in={show} mountOnEnter unmountOnExit>
      <Box sx={getContainerStyles()} onMouseLeave={handleMouseLeave}>
        <Box sx={getCloseButtonStyles()}>
          <IconButton
            size="small"
            onClick={handleCloseClick}
            sx={getCloseIconStyles()}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={getTitleStyles()}>
          <Typography variant="caption" sx={getTitleTextStyles()}>
            Preview do Mapa
          </Typography>
        </Box>

        <Box sx={getMapContainerStyles()}>
          <OrdersMap />
        </Box>
      </Box>
    </Slide>
  );
};

export default FloatingMapPreview;
